import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"padding":"34px"} }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "parent" }
const _hoisted_5 = {
  key: 0,
  class: "mt-80 mb-50"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_input_header = _resolveComponent("search-input-header")!
  const _component_QuizFilters = _resolveComponent("QuizFilters")!
  const _component_TabsComponent = _resolveComponent("TabsComponent")!
  const _component_archive_card = _resolveComponent("archive-card")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, { onOnSearchBarSubmit: _ctx.handleSearch }, {
    "header-left": _withCtx(() => [...(_cache[1] || (_cache[1] = [
      _createElementVNode("span", { class: "heading-4 heading-4 f-roboto fw-light" }, "Archive", -1)
    ]))]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "box-title" }, "Archive Page", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createVNode(_component_search_input_header, {
                value: _ctx.searchValue,
                onHandleSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSearch($event)))
              }, null, 8, ["value"])
            ]),
            _createVNode(_component_QuizFilters, { onOnFilterChange: _ctx.onFilterChange }, null, 8, ["onOnFilterChange"])
          ])
        ]),
        _createVNode(_component_TabsComponent, {
          tabs: _ctx.tabs,
          selectedValue: _ctx.tabName,
          onChange: _ctx.onTabChange
        }, {
          profile: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createElementVNode("p", null, "User info goes here.", -1)
          ]))]),
          settings: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createElementVNode("h2", null, "Settings Tab", -1),
            _createElementVNode("p", null, "Settings form goes here.", -1)
          ]))]),
          billing: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createElementVNode("h2", null, "Billing Tab", -1),
            _createElementVNode("p", null, "Billing info goes here.", -1)
          ]))]),
          _: 1
        }, 8, ["tabs", "selectedValue", "onChange"]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document) => {
            return (_openBlock(), _createElementBlock("div", {
              key: document.id,
              class: "child"
            }, [
              _createVNode(_component_archive_card, {
                id: document.id,
                name: document.name,
                "gradient-type": document.color,
                "last-edited": document.updated_at,
                progress: document.answers_progress / 100,
                "filter-values": document.filter_values,
                "business-function-id": _ctx.businessFunctionId,
                onOnUnarchive: _ctx.unarchiveQuiz,
                document: document
              }, null, 8, ["id", "name", "gradient-type", "last-edited", "progress", "filter-values", "business-function-id", "onOnUnarchive", "document"])
            ]))
          }), 128))
        ]),
        (_ctx.haveItems)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.pageMeta.current_page)
                ? (_openBlock(), _createBlock(_component_pagination, {
                    key: 0,
                    "current-page": _ctx.pageMeta.current_page,
                    "total-pages": _ctx.pageMeta.total,
                    meta: _ctx.pageMeta,
                    onHandleClick: _ctx.navigateToPage
                  }, null, 8, ["current-page", "total-pages", "meta", "onHandleClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onOnSearchBarSubmit"]))
}